import React from "react"
import ReactDom from "react-dom"
import Iframe from "react-iframe"
import { Collapse } from "reactstrap"

//funciones
import { urlReps, urlBase } from "../requests/utils"
import { getParams } from "../requests/req_reps"

//componentes
import Filtros from "../components/Filtros"

//Layout
import Main from "../Layouts/Main"

class Reporte extends React.Component {
  isOpen = true
  constructor(props) {
    super(props)
    this.state = {
      idVista: null,
      params: null,
      id: null,
      urlReport: "",
      descReport: null,
    }
    this.toggle = this.toggle.bind(this)
    this.obtienefiltros = this.obtienefiltros.bind(this)
    this.actualizaParams = this.actualizaParams.bind(this)
    this.actualizaFiltros = this.actualizaFiltros.bind(this)
    this.onReceiveMessage = this.onReceiveMessage.bind(this)
    this.childHandler = this.childHandler.bind(this)
  }

  componentDidMount() {
    const { match } = this.props
    let id = atob(match.params.id)
    this.setState({ idVista: id, descReport: atob(match.params.desc) })
    getParams(id, (x) => this.actualizaParams(x, true))
    window.addEventListener("message", this.onReceiveMessage)
  }

  componentWillUnmount() {
    this.setState({ filas: [] })
  }
  componentDidUpdate(prevProps, prevState) {
    /*
    const { idVista } = this.state;
    console.log(idVista , '  ___ ', prevState.idVista)
    if (prevState.idVista !== idVista) {
      getParams(idVista, (x) => this.actualizaParams(x, false));
    } else {
      this.actualizaFiltros();
    }*/
  }

  actualizaParams(datos, inicio) {
    const { idVista } = this.state
    if (idVista || inicio) {
      this.setState({ idVista: idVista, params: datos.data }, () => {
        this.actualizaFiltros()
      })
    }
  }

  actualizaFiltros() {
    const { idVista, params } = this.state
    var par = this.obtienefiltros(),
      d = document.getElementById("dv_filtros"),
      dv = document.getElementById("dv_reporte_aspx")
    ReactDom.unmountComponentAtNode(d)
    ReactDom.unmountComponentAtNode(dv)
    ReactDom.render(
      <Filtros
        filtros={par}
        datos={params}
        action={this.childHandler}
        id={idVista}
      />,
      d
    )
  }

  obtienefiltros() {
    var par = []
    const { params } = this.state
    if (params) {
      params.forEach((x) => {
        var f = par.filter((p) => p.filtro === x.nombre)
        if (f.length === 0) {
          var ant = x.nombreVariableAnt === null ? "No" : x.nombreVariableAnt,
            sig = x.nombreVariableSig === null ? "No" : x.nombreVariableSig

          par.push({
            filtro: x.nombre,
            visible: x.Visible,
            tipoDato: x.tipoDato,
            variable: x.nombreVariable,
            Anterior: ant,
            Siguiente: sig,
            idValor: x.idValor,
            valorPredeterminado: x.valorPredeterminado,
          })
        }
      })
      return par
    }
  }

  isNumeric(value) {
    return /^-{0,1}\d+$/.test(value)
  }

  childHandler(datosHijo, id = null) {
    let url = ""
    let powerBI = datosHijo.indexOf("powerBI")
    let paramsPowerBy = ""
    if (powerBI > -1) {
      let datos = datosHijo.split("&")
      let typesOfPowerBiStr = ""
      datos.forEach((item, index) => {
        if (item.indexOf("powerBiparameters") > -1) {
          typesOfPowerBiStr = item
          datos.splice(index, 1)
          return
        }
      })
      let typesOfPowerBi = typesOfPowerBiStr
        .replace("powerBiparameters=", "")
        .split(",")

      typesOfPowerBi.forEach((item, index) => {
        let parent = /^-{0,1}\d+$/
        datos.forEach((item_, index_) => {
          if (item_.indexOf(item) > -1) {
            paramsPowerBy += `${item} in (`
            let paramsSp = item_.split("=")
            paramsSp[1].split(",").forEach((v, i) => {
              paramsPowerBy += parent.test(v) ? `${parseInt(v)},` : `'${v}',`
            })

            paramsPowerBy =
              paramsPowerBy.substring(0, paramsPowerBy.length - 1) + ") and "
          }
        })
      })
      paramsPowerBy = paramsPowerBy.substring(0, paramsPowerBy.length - 4)
      url = `${urlBase}${datosHijo.substring(
        datosHijo.length,
        datosHijo.indexOf("Rpt=/") + 4
      )}&parametersPowerBi=${paramsPowerBy}`
    } else {
      url = urlReps + datosHijo
    }

    var dv = document.getElementById("dv_reporte_aspx")
    ReactDom.render(
      <Iframe
        url={url}
        width={`100%`}
        height={`515px`}
        id="IdFrame"
        display="initial"
        position="relative"
        allowFullScreen
        frameBorder={0}
        sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation allow-modals allow-downloads allow-top-navigation-by-user-activation"
      />,
      dv
    )
  }

  toggle(e) {
    this.isOpen = !this.isOpen
  }

  onReceiveMessage = (message) => {
    if (message.data) {
      const { error } = message.data
      if (error) {
        setTimeout(() => {
          ReactDom.unmountComponentAtNode(
            document.getElementById("dv_reporte_aspx")
          )
        }, 6000)
      }
    }
  }

  render() {
    const { descReport } = this.state
    return (
      <Main>
        <div className="dv_repor" id="dv_reporte">
          <div className="dv_Btn_Lbl_Rpt">
            <h2>{`Reporte ${descReport}`}</h2>
          </div>
          <Collapse isOpen={this.isOpen}>
            <div id="dv_filtros" />
          </Collapse>
          <div id="dv_reporte_aspx" />
        </div>
      </Main>
    )
  }
}

export default Reporte
